<template>
  <div class="screen_box" title="全屏/正常">
    <!-- <i @click="handleFullScreen" class="el-icon-full-screen"></i> -->
    <img @click="handleFullScreen" src="/icon/full.png"  />
  </div>
</template>

<script>
import screenfull from 'screenfull'

export default {
  data() {
    return {
      isFullscreen: false
    }
  },
  mounted() {
    this.init()
  },
  beforeDestroy() {
    this.destroy()
  },
  methods: {
    handleFullScreen() {
      if (!screenfull.isEnabled) {
        this.$message({
          message: 'you browser can not work',
          type: 'warning',
        })
        return false
      }
      screenfull.toggle()
    },
    change() {
      this.isFullscreen = screenfull.isFullscreen
    },
    init() {
      if (screenfull.isEnabled) {
        screenfull.on('change', this.change)
      }
    },
    destroy() {
      if (screenfull.enabled) {
        screenfull.off('change', this.change)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.screen_box {
  width: 40px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
//   &:hover{
//     background-color: #3072DD;
//   }
  img {
    width: 20px;
    height: 20px;
    font-size: 20px;
    &:before {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 40px;
      height: 40px;
    }
  }
}

</style>
